import constants from "../../core/constants";
import map from "lodash/fp/map";
import moment from "moment";

class CaptainInvoicesPageTransform {
  constructor() {
    "ngInject";

    this.fields = [
      { name: "basic_plan", title: "Basic Plan" },
      { name: "backup_plan", title: "Backup Plan" },
      { name: "deduction_plan", title: "Supply Deduction Plan" },
      { name: "status", title: "Status" },
      { name: "paid", title: "Paid" },
      { name: "start_date", title: "Start Date" },
      { name: "end_date", title: "End Date" },
      { name: "total_amount", title: "Total Amount" },
    ];
  }

  justify(data) {
    const format = (item) => {
      item.start_date = moment(item.start_date).format(constants.dateFormat);
      item.end_date = item.end_date
        ? moment(item.end_date).format(constants.dateFormat)
        : null;
      item.total_amount /= constants.currencyBy;

      return item;
    };
    return map(format)(data);
  }
}

export default CaptainInvoicesPageTransform;



// WEBPACK FOOTER //
// ./src/pages/captainInvoices/captainInvoices.transforms.js